export default {"src":"/_next/static/media/logout.92d09225.svg","height":32,"width":32};